/*
 * @Author: Michael Lam 127068684+MichaelLam888@users.noreply.github.com
 * @Date: 2025-07-08 11:46:50
 * @LastEditTime: 2025-07-08 11:55:10
 * @Description: 
 */
// src/components/Contact.jsx
import React from 'react';
import '../css/Contact.css';

const Contact = () => {
  return (
    <section className="contact" id="contact">
      <div className="contact-container">
        <h2 className="section-title">Contact Us</h2>

        <div className="contact-grid">
          <div className="contact-info">
            <p><strong>📍 Address:</strong> Unit 721-23, 7/F , Star Hse 3 ,Salisbury Rd ,Tsim Sha Tsui, Kowloon,</p>
            <p><strong>📧 Email:</strong> <a href="mailto:info@finchitsolutions.com">info@tptechgl.com</a></p>
            <p><strong>📞 Phone:</strong> <a href="tel:51831004">91395673</a></p>
            <p><strong>💬 WhatsApp:</strong> <a href="https://wa.me/85291395673" target="_blank" rel="noopener noreferrer">91395673</a></p>
          </div>

          <div className="map-container">
            <iframe
              title="GLOBAL TP TECHNOLOGY LIMITED"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.5659088854063!2d114.1661251120052!3d22.294427643021365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340400f32252543f%3A0xdc4e501f5cca3f47!2z5pif5YWJ6KGM!5e0!3m2!1szh-TW!2shk!4v1751946859454!5m2!1szh-TW!2shk"
             
              frameBorder="0"
              allowFullScreen
              loading="lazy"
              className="map"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
